var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoorWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5382 0.782715H0.46814V24.4815H13.5382V0.782715Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5879 10.4724H8.91083V15.4089H15.5879V10.4724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7878 12.6309L15.5879 17.2578V8.00391L21.7878 12.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.233154 0.838498L5.35178 0.438965V25.4634L0.233154 24.52V0.838498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.237 25.0609V0.829313L0.336223 1.19224V24.1774L5.237 25.0609ZM5.35181 25.4635L0.233154 24.5202V0.838521L5.35181 0.438965V25.4635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5544,
    height: 25.0244,
    fill: "white",
    transform: "translate(0.233154 0.438965)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorWhite);
export default __webpack_public_path__ + "static/media/door-white.57be137e3b2d69e550253851e9c34930.svg";
export { ForwardRef as ReactComponent };